import React from 'react'
import { Button, Form } from 'react-bootstrap'

const DestinationForm = ({ handleChange, destinationForm, handleSubmit, handleCancel }) => {
    return (
        <>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label>Destination Name<span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        type="text"
                        name="title"
                        value={destinationForm.title}
                        onChange={handleChange}
                        required
                    />
                </Form.Group>
                <div className="d-flex justify-content-end gap-2">
                    <Button variant="secondary" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary">
                        {destinationForm.id ? "Update" : "Submit"}
                    </Button>

                </div>
            </Form>
        </>
    )
}

export default DestinationForm
